import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { scoreColors } from '../../../../../helpers/utils';
import { createUseStyles } from 'react-jss';

const DetailsBox = ({ value, score, label, }) => {
  const classes = useStyles();
  const getScoreClass = () => {
    const isMaxScoreFive = true;
    return classNames(`${classes.detailsCondition} ${scoreColors(score, isMaxScoreFive)}`);
  };

  return (
    <div className={`${classes.detailsBox}`}>
      <span className={classes.detailsSublabel}>{label}</span>
      <span className={getScoreClass(score)} />
      <span>{value}</span>
    </div>
  )
}

const useStyles = createUseStyles({
  detailsCondition: {
    fontWeight: '600',
    display: 'inline-block',
    width: '12px',
    height: '12px',
    marginRight: '5px',
    marginBottom: '-1px',
    borderRadius: '50%',
  },
  detailsSublabel: {
    display: 'block',
    marginBottom: '5px',
    fontSize: '13px',
    color: '#8a8695',
  },
  detailsBox: {
    marginBottom: '25px',
    paddingLeft: '0',
    width: '42%',

  },
  '@media(max-width: 900px)': {
    detailsBox: {
      width: '100%',
    },
  },
})

DetailsBox.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  score: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
}

export default DetailsBox
